import React from 'react';

import { useAtom } from 'jotai';

import {
  useAccountInfo,
  useScheduledPayments,
} from '@consumer-frontend/nc-api';
import { Container } from '@consumer-frontend/shared-ui';

import { NcScheduledPayment } from './NcScheduledPayment';
import { accountIdAtom } from '../../store';
import { NcLoadingSpinner } from '../NcLoadingSpinner';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/payment/scheduled-payments.scss';

export type NcScheduledPaymentsT = React.FC<{ isLoading?: boolean; }>;

export const NcScheduledPayments: NcScheduledPaymentsT = ({ isLoading }) => {
  const [accountId] = useAtom(accountIdAtom);
  const { accountInfo } = useAccountInfo(accountId);
  const loanNumber = accountInfo?.loanNumber;

  const { scheduledPayments = [] } = useScheduledPayments({ accountId, loanNumber });

  const hasScheduledPayments = scheduledPayments.length > 0;

  return (
    <Container className="scheduled-payments-container d-flex flex-column" hasBoxShadow>
      <div className="scheduled-payment-title">
        <div aria-level={2} className="h4 semi-bold" role="heading">
          Scheduled Payments
        </div>
        <p className="subheading">For the next 35 days</p>
      </div>

      <div className="scheduled-payments-list" role={!isLoading && hasScheduledPayments ? 'list' : undefined}>
        {isLoading && <NcLoadingSpinner />}

        {!isLoading && (
          hasScheduledPayments
            ? (scheduledPayments.map((payment) => (
              <NcScheduledPayment key={payment.id} {...payment} />
            )))
            : (<p className="no-scheduled-payments">No scheduled payments to show.</p>)
        )}
      </div>
    </Container>
  );
};
